/* globals google*/
import jquery from 'jquery';
import HabEvents from '../../Global/habitaclia-events';
import UIKeyCodes from '../../Global/keycodes';
import Functions from './functions';

export default class WideMedia {
    constructor(WideMediaDTO, type, pos, url) {

        this.__wideMediaDTO = WideMediaDTO;
        this.__type = type;
        this.__position = pos;
        this.__url = url;
        this.__body = document.body;
        this.initContainer();

        this.__windowScroll = document.documentElement.scrollTop;

        this.__countMedia = this.__wideMediaDTO.contImg + this.__wideMediaDTO.contVideo;
        this.__isBackHistory = false;

        if (this.__wideMediaDTO.isMapaVisible) {
            this.__gMMap;
            this.__bMapInitialized = false;
        }
        this.registerEvents();
        this.setType();
        this.setVisible();

        jquery.publish(HabEvents.EventsEnum.ShowWideMedia, this.__url);
    }

    initContainer() {
        
        const template = document.getElementById('{{js-wide-media}}').cloneNode(true);
        template.id = this.getId(template.id);
        const templateChildren = template.querySelectorAll('[id*="{{"]');
        templateChildren.forEach((element) => {
            element.id = this.getId(element.id);
        });
        this.__body.appendChild(template);
        this.__wideMediaContainer = document.getElementById('js-wide-media');
        this.__wideCloseBtn = document.getElementById('js-wide-close');
        this.__wideMediaContent = document.getElementById('js-wide-content');
        this.__widePhotoBtn = document.getElementById('js-wide-image-btn');
        this.__wideVideoBtn = document.getElementById('js-wide-video-btn');
        this.__wideMapBtn = document.getElementById('js-wide-map-btn');
        this.__wide3DBtn = document.getElementById('js-wide-3d-btn');
        this.__wide360Btn = document.getElementById('js-wide-360-btn');
        this.__wideStreetBtn = document.getElementById('js-wide-street-btn');
        this.__wideThumbVideoBtn = document.getElementById('js-wide-thumb-video');
        this.__wideThumbMapBtn = document.getElementById('js-wide-thumb-map');
        this.__wideThumbStreetBtn = document.getElementById('js-wide-thumb-street');
        this.__wideThumb3DBtn = document.getElementById('js-wide-thumb-vid3d');
        this.__wideThumb360Btn = document.getElementById('js-wide-thumb-vid360');
        this.__wideTitle = document.getElementById('js-wide-title');
        this.__wideFooter = document.getElementById('js-wide-footer');
        this.__wideNextBtn = document.getElementById('js-wide-next');
        this.__widePrevBtn = document.getElementById('js-wide-prev');
        this.__btnShareFacebook = document.getElementById('js-share-facebook');
        this.__btnShareTwitter = document.getElementById('js-share-twitter');
        this.__btnShareEnviarAmigo = document.getElementById('js-wide-share-friend-btn');
        this.__wideSubmitButton = document.getElementById('js-wide-submit');
        this.__wideThumbContainer = document.getElementById('js-wide-thumb');
        this.__wideThumbButton = document.getElementById('js-wide-thumb-btn');
        this.__wideThumbList = document.getElementById('js-wide-thumb-list');
        this.__wideThumbScroll = document.getElementById('js-wide-thumb-container');
        this.__wideContactBtn = document.getElementById('js-wide-contact');
        this.__lastThumbPosition = 0;

        if (!this.__wideMediaDTO.vid360 || this.__wideMediaDTO.vid360.contador <= 0) {
            this.__wide360Btn.remove();
            this.__wideThumb360Btn.remove();
        }
        if (!this.__wideMediaDTO.vid3D || this.__wideMediaDTO.vid3D.contador <= 0) {
            this.__wide3DBtn.remove();
            this.__wideThumb3DBtn.remove();
        }
        if (this.__wideMediaDTO.contVideo <= 0) {
            this.__wideVideoBtn.remove();
            this.__wideThumbVideoBtn.style.display = 'none';
        }
        if (this.__wideMediaDTO.contImg <= 0) {
            this.__widePhotoBtn.remove();
        }
        if (!this.__wideMediaDTO.isMapaVisible) {
            this.__wideMapBtn.remove();
            this.__wideThumbMapBtn.remove();
        }
        if (!this.__wideMediaDTO.isStreetVisible) {
            this.__wideStreetBtn.remove();
            this.__wideThumbStreetBtn.remove();

        }

        if (document.querySelector('.formenviado')) {
            this.copyPhoneToWide();
        }

        this.showThumbnails();
    }

    getId(templateId) {
        const expression = new RegExp(/[-\w]+/g);
        return templateId.match(expression);
    }

    registerEvents() {
        if (this.__wideThumbButton) {
            this.__wideThumbButton.addEventListener('click', () => {
                if (this.__wideThumbContainer.classList.contains('wide-thumb-open')) {
                    this.__wideThumbContainer.classList.remove('wide-thumb-open');
                    jquery.publish(HabEvents.EventsEnum.WideMediaThumbnails, 'wide-thumb-hide');
                } else {
                    this.__wideThumbContainer.classList.add('wide-thumb-open');
                    jquery.publish(HabEvents.EventsEnum.WideMediaThumbnails, 'wide-thumb-show');
                }
            });
        }
        if (this.__btnShareEnviarAmigo) {
            this.__btnShareEnviarAmigo.addEventListener('click', () => {
                jquery.publish(HabEvents.EventsEnum.ClickCompartirFicha, this.__wideMediaDTO.tipReg + this.__wideMediaDTO.codigoAnuncio);
            });
        }

        if (this.__btnShareTwitter) {
            this.__btnShareTwitter.addEventListener('click', () => {
                jquery.publish(HabEvents.EventsEnum.ClickCompartirFicha, this.__wideMediaDTO.tipReg + this.__wideMediaDTO.codigoAnuncio);
            });
        }
        if (this.__btnShareFacebook) {
            this.__btnShareFacebook.addEventListener('click', () => {
                jquery.publish(HabEvents.EventsEnum.ClickCompartirFicha, this.__wideMediaDTO.tipReg + this.__wideMediaDTO.codigoAnuncio);
            });
        }
        if (this.__wideCloseBtn) {
            this.__wideCloseBtn.addEventListener('click', () => {
                jquery.publish(HabEvents.EventsEnum.WideMedia, ['cerrar-button', this.__type]);
                this.closeWideMedia();
            });
        }
        if (this.__wideNextBtn) {
            this.__wideNextBtn.addEventListener('click', () => this.nextMedia());
        }
        if (this.__widePrevBtn) {
            this.__widePrevBtn.addEventListener('click', () => this.prevMedia());
        }
        if (this.__widePhotoBtn) {
            this.__widePhotoBtn.addEventListener('click', () => {
                this.__position = 0;
                this.showPhoto();
                this.resetHorizontalScroll();
                this.updateSelected();
            });
        }

        if (this.__wideVideoBtn) {
            this.__wideVideoBtn.addEventListener('click', () => {
                this.__position = 0;
                this.showVideo();
                this.updateSelected();
            });
        }
        if (this.__wideMapBtn) {
            this.__wideMapBtn.addEventListener('click', () => {
                this.showMap();
                this.updateSelected();
            });
        }
        if (this.__wideStreetBtn) {
            this.__wideStreetBtn.addEventListener('click', () => this.showStreet());
        }
        if (this.__wide3DBtn) {
            this.__wide3DBtn.addEventListener('click', () => {
                this.__position = 0;
                this.show3D();
                this.updateSelected();
            });
        }
        if (this.__wide360Btn) {
            this.__wide360Btn.addEventListener('click', () => {
                this.__position = 0;
                this.show360();
                this.updateSelected();
            });
        }
        if (this.__wideContactBtn) {
            this.__wideContactBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.closeToContact();
            });
        }

        if (this.__wideSubmitButton) {
            this.__wideSubmitButton.addEventListener('click', (e) => {
                jquery.publish(HabEvents.EventsEnum.ContactFooterWidemedia);
                this.pasteTextToContactForm();
                if (this.__wideMediaDTO.userIsLogged === "True") {
                    e.preventDefault();
                    document.getElementById('js-wide-form').classList.add('wide-form-sending');
                    this.__wideSubmitButton.value = this.__wideSubmitButton.dataset.sending;
                    document.getElementById('submitSolicitudes').click();
                } else {
                    e.preventDefault();
                    this.closeToContact();
                }
            });
            jquery.subscribe(HabEvents.EventsEnum.ErroresForm, ()=>{
                this.closeToContact();
            });
        }

        this.__body.addEventListener('keyup', (e) => {
            if (document.querySelectorAll('.wide-media-open').length > 0) {
                if (e.which === UIKeyCodes.UIKeyCodesEnum.RIGHT) {
                    this.nextMedia();
                } else if (e.which === UIKeyCodes.UIKeyCodesEnum.LEFT) {
                    this.prevMedia();
                } else if (e.which === UIKeyCodes.UIKeyCodesEnum.ESCAPE) {
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['cerrar-escape', this.__type]);
                    this.closeWideMedia();
                }
            }
        });
        document.getElementById('js-wide-share-btn').addEventListener('click', () => {
            const shareList = document.getElementById('js-wide-share-list');
            if (shareList.classList.contains('active')) {
                shareList.classList.remove('active');
            } else {
                shareList.classList.add('active');
            }
        }
        );
        document.getElementById('js-wide-share-friend-btn').addEventListener('click', () => {
            Functions.CreateWindow(jquery(this).attr('data-window'), 740, 500);
        });
        window.addEventListener("popstate", () => {
            this.__isBackHistory = true;
            this.closeWideMedia();
        });
        jquery.subscribe(HabEvents.EventsEnum.UrlAjaxSolicitudError, () => {
            if (document.querySelectorAll('.wide-media-open').length > 0) {
                this.closeToContact();
                document.getElementById('js-wide-form').classList.remove('wide-form-sending');
                this.__wideSubmitButton.value = this.__wideSubmitButton.dataset.contact;
            }
        });
        jquery.subscribe(HabEvents.EventsEnum.ConfirmacionSolicitudEnviada, () => {
            this.copyPhoneToWide();
        });
    }

    setType() {
        switch (this.__type) {
            case 'vid360':
                this.__position = 0;
                this.show360();
                break;
            case 'vid3D':
                this.__position = 0;
                this.show3D();
                break;
            case 'video':
                this.showVideo();
                break;
            default:
                this.showPhoto();
        }
    }

    setVisible() {
        const stateObj = { page: "actual" };
        const title = document.title;
        this.__body.classList.add('wmLockScrollMainWindow');
        this.__wideMediaContainer.classList.add('wide-media-open');
        history.pushState(stateObj, title, window.location.href);
        this.updateSelected();
    }

    nextMedia() {
        this.deleteCoverClass();
        switch (this.__type) {
            case 'vid3D':
                if (this.__position < this.__wideMediaDTO.vid3D.contador - 1) {
                    this.__position = this.__position + 1;
                    this.show3D();
                } else if (this.__wideMediaDTO.vid360.contador > 0) {
                    this.__position = 0;
                    this.__type = 'vid360';
                    this.show360();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'vid3D-vid360']);
                } else if (this.__wideMediaDTO.contImg > 0) {
                    this.__type = 'img';
                    this.__position = 0;
                    this.showPhoto();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'vid3D-foto']);
                    this.resetHorizontalScroll();
                } else if (this.__wideMediaDTO.contVideo > 0) {
                    this.__position = 0;
                    this.__type = 'video';
                    this.showVideo();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'foto-video']);
                } else {
                    this.__type = 'special';
                    this.showSpecial();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'foto-mas']);
                }
                break;
            case 'vid360':
                if (this.__position < this.__wideMediaDTO.vid360.contador - 1) {
                    this.__position = this.__position + 1;
                    this.show360();
                } else if (this.__wideMediaDTO.contImg > 0) {
                    this.__type = 'img';
                    this.__position = 0;
                    this.showPhoto();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'vid3D-foto']);
                    this.resetHorizontalScroll();
                } else if (this.__wideMediaDTO.contVideo > 0) {
                    this.__position = 0;
                    this.__type = 'video';
                    this.showVideo();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'foto-video']);
                } else {
                    this.__type = 'special';
                    this.showSpecial();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'foto-mas']);
                }
                break;
            case 'img':
                if (this.__position < this.__wideMediaDTO.contImg - 1) {
                    this.__position = this.__position + 1;
                    this.showPhoto();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'foto-foto']);
                } else {
                    if (this.__wideMediaDTO.contVideo > 0) {
                        this.__position = 0;
                        this.__type = 'video';
                        this.showVideo();
                        jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'foto-video']);
                    } else {
                        this.__type = 'special';
                        this.showSpecial();
                        jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'foto-mas']);
                    }
                }
                break;
            case 'video':
                if (this.__position < this.__wideMediaDTO.contVideo - 1) {
                    this.__position = this.__position + 1;
                    this.showVideo();
                } else {
                    this.__type = 'special';
                    this.showSpecial();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'video-mas']);
                }
                break;
            case 'special':
                if (this.__wideMediaDTO.isMapaVisible) {
                    this.__position = 0;
                    this.__type = 'map';
                    this.showPreMap();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'mas-mapa']);
                } else {
                    this.__position = 0;
                    this.__type = 'similars';
                    this.showSimilars();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'special-similar']);
                }
                break;
            case 'map':
                if (this.__wideMediaDTO.isStreetVisible) {
                    this.__position = 0;
                    this.__type = 'street';
                    this.showPreStreet();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'mapa-street']);
                } else {
                    this.__position = 0;
                    this.__type = 'similars';
                    this.showSimilars();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'mapa-similar']);
                }
                break;
            case 'street':
                this.__position = 0;
                this.__type = 'similars';
                this.showSimilars();
                jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'street-similar']);
                break;
            case 'similars':
                if (this.__wideMediaDTO.vid3D.contador > 0) {
                    this.__position = 0;
                    this.__type = 'vid3D';
                    this.show3D();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'mas-vid3D']);
                } else if (this.__wideMediaDTO.vid360.contador > 0) {
                    this.__position = 0;
                    this.__type = 'vid360';
                    this.show360();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'mas-vid360']);
                } else {
                    this.__position = 0;
                    this.__type = 'img';
                    this.showPhoto();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'street-foto']);
                    this.resetHorizontalScroll();
                }
                break;
        }
        this.updateSelected();
        this.updateHorizontalScroll();
    }

    prevMedia() {
        this.deleteCoverClass();
        switch (this.__type) {
            case 'vid3D':
                if (this.__position > 0) {
                    this.__position = this.__position - 1;
                    this.show3D();
                } else {
                    if (this.__wideMediaDTO.isStreetVisible) {
                        this.__position = 0;
                        this.__type = 'street';
                        this.showStreet();
                        jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'vid3D-street']);
                    } else if (this.__wideMediaDTO.isMapaVisible) {
                        this.__position = 0;
                        this.__type = 'map';
                        this.showPreMap();
                        jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'vid3D-map']);
                    } else {
                        this.__type = 'special';
                        this.showSpecial();
                        jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'vid3D-mas']);
                    }
                }
                break;
            case 'vid360':
                if (this.__position > 0) {
                    this.__position = this.__position - 1;
                    this.show360();
                } else {
                    if (this.__wideMediaDTO.vid3D.contador > 0) {
                        this.__type = 'vid3D';
                        this.__position = this.__wideMediaDTO.vid3D.contador - 1;
                        this.show3D();
                        jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'vid360-vid3D']);
                    } else if (this.__wideMediaDTO.isStreetVisible) {
                        this.__position = 0;
                        this.__type = 'street';
                        this.showPreStreet();
                        jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'vid360-street']);
                    } else if (this.__wideMediaDTO.isMapaVisible) {
                        this.__position = 0;
                        this.__type = 'map';
                        this.showPreMap();
                        jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'vid360-map']);
                    } else {
                        this.__type = 'special';
                        this.showSpecial();
                        jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'vid360-mas']);
                    }
                }
                break;
            case 'img':
                if (this.__position > 0) {
                    this.__position = this.__position - 1;
                    this.showPhoto();
                } else {
                    if (this.__wideMediaDTO.vid360.contador > 0) {
                        this.__position = this.__wideMediaDTO.vid360.contador - 1;
                        this.__type = 'vid360';
                        this.show360();
                        jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'foto-vid360']);
                    } else if (this.__wideMediaDTO.vid3D.contador > 0) {
                        this.__type = 'vid3D';
                        this.__position = this.__wideMediaDTO.vid3D.contador - 1;
                        this.show3D();
                        jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'foto-vid3D']);
                    } else if (this.__wideMediaDTO.isStreetVisible) {
                        this.__position = 0;
                        this.__type = 'street';
                        this.showPreStreet();
                        jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'foto-street']);
                    } else if (this.__wideMediaDTO.isMapaVisible) {
                        this.__position = 0;
                        this.__type = 'map';
                        this.showPreMap();
                        jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'foto-map']);
                    } else if (this.__wideMediaDTO.contVideo > 0) {
                        this.__position = this.__wideMediaDTO.contVideo - 1;
                        this.__type = 'video';
                        this.showVideo();
                        jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'foto-video']);
                    } else {
                        this.__type = 'special';
                        this.showSpecial();
                        jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'foto-mas']);
                    }
                }
                break;
            case 'video':
                if (this.__position > 0) {
                    this.__position = this.__position - 1;
                    this.__type = 'video';
                    this.showVideo();
                } else if (this.__wideMediaDTO.contImg > 0) {
                    this.__position = this.__wideMediaDTO.contImg - 1;
                    this.__type = 'img';
                    this.showPhoto();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'video-foto']);
                } else if (this.__wideMediaDTO.vid360.contador > 0) {
                    this.__position = this.__wideMediaDTO.vid360.contador - 1;
                    this.__type = 'vid360';
                    this.show360();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'foto-vid360']);
                } else if (this.__wideMediaDTO.vid3D.contador > 0) {
                    this.__type = 'vid3D';
                    this.__position = this.__wideMediaDTO.vid3D.contador - 1;
                    this.show3D();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'foto-vid3D']);
                }
                break;
            case 'special':
                if (this.__wideMediaDTO.contVideo > 0) {
                    this.__position = this.__wideMediaDTO.contVideo - 1;
                    this.__type = 'video';
                    this.showVideo();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'mas-video']);
                } else if (this.__wideMediaDTO.contImg > 0) {
                    this.__type = 'img';
                    this.__position = this.__wideMediaDTO.contImg - 1;
                    this.showPhoto();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'mas-foto']);
                } else if (this.__wideMediaDTO.vid360.contador > 0) {
                    this.__position = this.__wideMediaDTO.vid360.contador - 1;
                    this.__type = 'vid360';
                    this.show360();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'foto-vid360']);
                } else if (this.__wideMediaDTO.vid3D.contador > 0) {
                    this.__type = 'vid3D';
                    this.__position = this.__wideMediaDTO.vid3D.contador - 1;
                    this.show3D();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['siguiente', 'foto-vid3D']);
                }
                break;
            case 'map':
                this.__type = 'special';
                this.showSpecial();
                jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'map-mas']);
                break;
            case 'street':
                this.__position = 0;
                this.__type = 'map';
                this.showPreMap();
                jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'street-map']);
                break;
            case 'similars':
                if (this.__wideMediaDTO.isStreetVisible) {
                    this.__position = 0;
                    this.__type = 'street';
                    this.showPreStreet();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'foto-street']);
                } else if (this.__wideMediaDTO.isMapaVisible) {
                    this.__position = 0;
                    this.__type = 'map';
                    this.showPreMap();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'foto-map']);
                } else if (this.__wideMediaDTO.contVideo > 0) {
                    this.__position = this.__wideMediaDTO.contVideo - 1;
                    this.__type = 'video';
                    this.showVideo();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'foto-video']);
                } else {
                    this.__type = 'special';
                    this.showSpecial();
                    jquery.publish(HabEvents.EventsEnum.WideMedia, ['anterior', 'foto-mas']);
                }
                break;
        }
        this.updateSelected();
        this.updateHorizontalScroll();
    }

    copyPhoneToWide() {
        if (document.querySelectorAll('.wide-media .formenviado').length === 0) {
            if (this.__wideContactBtn) {
                this.__wideContactBtn.remove();
            }
            if (document.getElementById('js-wide-form')) {
                document.getElementById('js-wide-form').remove();
            }
            const sendHtml = document.querySelector('.formenviado').cloneNode(true);
            this.__wideFooter.appendChild(sendHtml);
            if (document.querySelector('.wide-media .ico-llamar img')) {
                document.querySelector('.wide-media .ico-llamar img').removeAttribute('style');
            }
        }
    }

    closeToContact() {
        this.__body.classList.remove('wide-media-cover');
        jquery.publish(HabEvents.EventsEnum.WideMedia, ['click', 'contactaranunciante']);
        setTimeout(() => {
            this.closeWideMediaNoScroll();
            Functions.ScrollTo('#js-contact', 0, 0);
        }, 1100);
    }

    pasteTextToContactForm() {
        const textToCopy = document.getElementById('js-wide-message').value;
        if (textToCopy !== "") {
            document.getElementById('Mensaje').value = textToCopy;
        }
    }

    showMedia(item) {
        this.__wideMediaContent.innerHTML = '';
        this.__wideMediaContent.innerHTML = item;
        this.setTitle();
    }

    showPhoto() {
        const imageXL = this.__wideMediaDTO.image[this.__position].URLXL;
        const imageG = this.__wideMediaDTO.image[this.__position].URLG;
        const foto = `<div id="js-wide-content-photo" class="wide-content-photo" style="background-image:url(${imageXL}), url(${imageG});"></div>`;
        this.__type = 'img';
        this.setBtnActive(this.__widePhotoBtn);
        this.showMedia(foto);
    }

    showVideo() {
        this.hideThumbnails();
        let video;
        if (this.__wideMediaDTO.video[this.__position].Platform === "Inmofactory") {
            video = `<video class="wide-content-video" width="83%" height="80%" controls controlsList="nodownload" autoplay><source src="${this.__wideMediaDTO.video[this.__position].URL}"></video>`;
        } else {
            video = `<iframe width="83%" height="90%" class="wide-content-video" src="${this.__wideMediaDTO.video[this.__position].URL}" frameborder="0" allowfullscreen=""></iframe>`;
        }
        this.__type = 'video';
        this.setBtnActive(this.__wideVideoBtn);
        this.showMedia(video);
    }

    showSpecial() {
        let text;
        const wideBtnActive = document.querySelector('.wide-btn .active');
        if (wideBtnActive) {
            wideBtnActive.classList.remove('active');
        }
        if (this.__wideMediaDTO.contImg > 9) {
            text = `<div class="wide-content-special wide-content-center">${this.__wideMediaDTO.Translate.interested}<div class="wide-content-special-button"><a id="js-wide-special-contact" href="#js-contact" class="button button-orange">${this.__wideMediaDTO.Translate.contact}</a></div></div>`;
        } else {
            text = `<div class="wide-content-special wide-content-center">${this.__wideMediaDTO.Translate.morePhoto}<div class="wide-content-special-button"><a id="js-wide-special-contact" href="#js-contact" class="button button-orange">${this.__wideMediaDTO.Translate.morePhotoContact}</a></div></div>`;
        }
        this.showMedia(text);
        this.bindSpecial();
    }

    showSimilars() {
        this.hideThumbnails();
        const similarsItemsSelector = document.querySelector('.sim-container-horizontal .sim-full');
        let similarsNumber = 0;
        let similarsItems;
        if (similarsItemsSelector) {
            similarsItems = similarsItemsSelector.cloneNode(true);
            similarsNumber = similarsItems.childElementCount;
        } else {
            similarsNumber = 0;
        }
        if (similarsNumber > 6) {
            similarsNumber = 6;
        }
        if (similarsNumber === 0) {
            this.nextMedia();
        } else {
            const wideBtnActive = document.querySelector('.wide-btn .active');
            if (wideBtnActive) {
                wideBtnActive.classList.remove('active');
            }
            const similarsTitle = document.querySelector('#js-similar-top .title').innerHTML;
            let titulo = `<li class="wide-similar-title">${similarsTitle}</li>`;
            let similarsConcat = `<ul class="wide-similars">${titulo}`;
            for (let i = 0; i < similarsNumber; i++) {
                similarsConcat = similarsConcat + similarsItems.children[i].outerHTML;
            }
            similarsConcat = similarsConcat + '</ul>';
            this.showMedia(similarsConcat);

            const wideSimilars = document.querySelectorAll('.wide-similars');
            Array.from(wideSimilars).forEach(link => {
                link.addEventListener('click', (e) => {
                    const url = e.target.closest('.sim-item').getAttribute('data-url');
                    const newUrl = url.replace(/&lo=63/gi, '&lo=70');
                    jquery.publish(HabEvents.EventsEnum.clickSimilarWidemedia);
                    document.location.href = newUrl;
                });
            });
        }
    }

    showPreMap(){
        this.hideThumbnails();
        const map = `<div id="js-wide-map" class="wide-content-map" style="background-image:url(${this.__wideMediaDTO.mapImage});"><div class="wide-content-center"><button id="js-wide-premap-btn" class="button">${this.__wideMediaDTO.Translate.viewMap}</button></div></div>`;
        this.__type = 'map';
        this.showMedia(map);
        this.setBtnActive(this.__wideMapBtn);
        this.bindPre();
    }

    showPreStreet(){
        this.hideThumbnails();
        const street = `<div id="js-wide-map" class="wide-content-map"></div><div id="js-wide-street" class="wide-content-map" style="background-image:url(${this.__wideMediaDTO.streetImage});"><div class="wide-content-center"><button id="js-wide-premap-btn" class="button">${this.__wideMediaDTO.Translate.viewStreet}</button></div></div>`;
        this.__type = 'street';
        this.showMedia(street);
        this.setBtnActive(this.__wideStreetBtn);
        this.bindPre();
    }

    showMap() {
        this.hideThumbnails();
        const map = `<div id="js-wide-map" class="wide-content-map"></div>`;
        this.__type = 'map';
        this.showMedia(map);
        this.setBtnActive(this.__wideMapBtn);
        this.initializeMap();
    }

    showStreet() {
        this.hideThumbnails();
        const street = `<div id="js-wide-map" class="wide-content-map"></div><div id="js-wide-street" class="wide-content-map"></div>`;
        this.__type = 'street';
        this.showMedia(street);
        this.setBtnActive(this.__wideStreetBtn);
        this.initializeStreetView();
    }

    show3D() {
        this.hideThumbnails();
        const video3D = this.__wideMediaDTO.vid3D.videos[this.__position].URL;
        const cont3d = `<iframe class="wide-content-vr" width="83%" height="90%" src="${video3D}" frameborder="0" scrolling="no" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>`;
        this.__type = 'vid3D';
        this.setBtnActive(this.__wide3DBtn);
        this.showMedia(cont3d);
    }

    show360() {
        this.hideThumbnails();
        const video360 = this.__wideMediaDTO.vid360.videos[this.__position].URL;
        const cont360 = `<iframe class="wide-content-vr" width="83%" height="90%" src="${video360}" frameborder="0" scrolling="no" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>`;
        this.__type = 'vid360';
        this.setBtnActive(this.__wide360Btn);
        this.showMedia(cont360);
    }

    bindSpecial() {
        document.getElementById('js-wide-special-contact').addEventListener('click', () => {
            jquery.publish(HabEvents.EventsEnum.ContactSpecialWidemedia);
            this.closeWideMediaNoScroll();
        }
        );
    }

    bindPre() {
        document.getElementById('js-wide-premap-btn').addEventListener('click', ()=>{
            if(this.__type==='map'){
                this.showMap();
            }else{
                this.showStreet();
            }
        });
    }

    setBtnActive(button) {
        const wideBtnActive = document.querySelector('.wide-btn .active');
        if (wideBtnActive) {
            wideBtnActive.classList.remove('active');
        }
        button.children[0].classList.add('active');
    }

    setTitle() {
        const text = this.__wideMediaDTO.Translate.fromText;
        const pos = this.__position + 1;
        const posvideo = this.__wideMediaDTO.contImg + pos;
        switch (this.__type) {
            case 'video':
                this.__wideTitle.innerHTML = `<span class="wide-title-num">${posvideo} ${text} ${this.__countMedia}</span>  <span class="wide-title-text"></span>`;
                this.__wideTitle.style.display = 'block';
                this.__wideFooter.style.display = 'block';
                break;
            case 'img':
                if (this.__wideMediaDTO.image[this.__position].Titulo !== "" && this.__wideMediaDTO.image[this.__position].Titulo !== null) {
                    this.__wideTitle.innerHTML = `<span class="wide-title-num"> ${pos} ${text} ${this.__countMedia} </span> - <span class="wide-title-text"> ${this.__wideMediaDTO.image[this.__position].Titulo}</span>`;
                } else {
                    this.__wideTitle.innerHTML = `<span class="wide-title-num">${pos} ${text} ${this.__countMedia}</span>`;
                }
                this.__wideTitle.style.display = 'block';
                this.__wideFooter.style.display = 'block';
                break;
            default:
                this.__wideTitle.style.display = 'none';
                this.__wideFooter.style.display = 'none';
        }
    }

    initializeMap() {
        this.__gMPosition = new google.maps.LatLng(this.__wideMediaDTO.GMapsConfig.VGPSLat, this.__wideMediaDTO.GMapsConfig.VGPSLon);
        const myMapStyleDef = [
            {
                featureType: "poi.business",
                elementType: "labels.text",
                stylers: [
                    { visibility: "off" }
                ]
            }
        ];
        const myMapStyle = new google.maps.StyledMapType(myMapStyleDef, { name: "Mapa" });
        const myOptions = {
            mapTypeControlOptions: {
                mapTypeIds: ["myMapStyle", google.maps.MapTypeId.HYBRID]
            },
            zoom: this.__wideMediaDTO.GMapsConfig.zoom,
            center: this.__gMPosition,
            mapTypeId: "myMapstyle",
            scrollwheel: true,
            streetViewControl: false
        };
        this.__gMMap = new google.maps.Map(document.getElementById("js-wide-map"), myOptions);
        this.__gMMap.mapTypes.set("myMapStyle", myMapStyle);
        this.__gMMap.setMapTypeId("myMapStyle");
        google.maps.InfoWindow.prototype.setContent = function () {
            const that = this;
            setTimeout(() => { that.close(); }, 200);
        };
        /* jshint ignore:start */
        if (this.__wideMediaDTO.GMapsConfig.mostrarHab === 1) {
            const gMMarker = new google.maps.Marker({
                position: this.__gMPosition,
                map: this.__gMMap,
                icon: this.__wideMediaDTO.urlMapIcon,
                draggable: false
            });
        }
        /* jshint ignore:end */
        this.__bMapInitialized = true;
    }

    initializeStreetView() {
        if (!this.__bMapInitialized) {
            this.initializeMap();
        }
        const panoramaOptions = {
            position: this.__gMPosition,
            pov: {
                heading: this.__wideMediaDTO.GMapsConfig.StreetView.heading || 34,
                pitch: this.__wideMediaDTO.GMapsConfig.StreetView.pitch || 10,
                zoom: this.__wideMediaDTO.GMapsConfig.StreetView.zoom || 1
            }
        };
        const panorama = new google.maps.StreetViewPanorama(document.getElementById("js-wide-street"), panoramaOptions);
        this.__gMMap.setStreetView(panorama);
    }

    closeWideMedia() {
        this.closeWideMediaNoScroll();
        document.documentElement.scrollTop = this.__windowScroll;
        if (!this.__isBackHistory) {
            window.history.back(-1);
        }
    }

    closeWideMediaNoScroll() {
        this.__body.classList.remove('wmLockScrollMainWindow');
        this.__wideMediaContainer.classList.remove('wide-media-open');
        this.__body.classList.remove('wide-media-cover');
        setTimeout(() => {
            this.__body.classList.remove('wide-media-cover');
            this.__wideMediaContainer.remove();
        }, 650);
    }

    showThumbnails() {
        let count = 0;
        this.__wideMediaDTO.image.forEach((image) => {
            const img = new Image();
            img.src = image.URL;
            const li = document.createElement("li");
            li.setAttribute('data-wide-order', count);
            li.setAttribute('data-wide-type', 'img');
            li.appendChild(img);
            this.__wideThumbList.insertBefore(li, this.__wideThumbVideoBtn);
            count++;
        });
        this.bindThumbnails();
    }

    bindThumbnails() {
        this.__wideThumbList.addEventListener('click', (e) => {
            if (e.target.nodeName === "IMG" || e.target.nodeName === "LI") {
                const liParent = e.target.closest('li');
                this.__position = parseInt(liParent.getAttribute('data-wide-order'));
                this.__type = liParent.getAttribute('data-wide-type');
                this.updateSelected();
                switch (this.__type) {
                    case 'map':
                        this.showMap();
                        break;
                    case 'street':
                        this.showStreet();
                        break;
                    case 'vid360':
                        this.show360();
                        break;
                    case 'vid3D':
                        this.show3D();
                        break;
                    case 'video':
                        this.showVideo();
                        break;
                    case 'similars':
                        this.showSimilars();
                        break;
                    default:
                        this.showPhoto();
                }
                this.updateHorizontalScroll();
                jquery.publish(HabEvents.EventsEnum.WideMediaThumbnails, 'wide-thumb-change');
            }
        });
    }

    hideThumbnails() {
        if (this.__wideThumbContainer.classList.contains('wide-thumb-open')) {
            this.__wideThumbContainer.classList.remove('wide-thumb-open');
        }
    }

    updateSelected() {
        const selectedThumb = document.querySelector('.wide-thumb-selected');
        if (selectedThumb) {
            selectedThumb.classList.remove('wide-thumb-selected');
        }
        switch (this.__type) {
            case 'map':
                this.__wideThumbMapBtn.classList.add('wide-thumb-selected');
                break;
            case 'street':
                this.__wideThumbStreetBtn.classList.add('wide-thumb-selected');
                break;
            case 'vid360':
                this.__wideThumb360Btn.classList.add('wide-thumb-selected');
                break;
            case 'vid3D':
                this.__wideThumb3DBtn.classList.add('wide-thumb-selected');
                break;
            case 'video':
                this.__wideThumbVideoBtn.classList.add('wide-thumb-selected');
                break;
            default:
                this.__wideThumbList.children[this.__position].classList.add('wide-thumb-selected');
        }
    }

    updateHorizontalScroll() {
        let scrollHorizontal = 118;
        if (this.__type !== 'img') {
            this.__lastThumbPosition = 400;
        } else if (this.__lastThumbPosition > this.__position) {
            scrollHorizontal = -scrollHorizontal;
        }
        if (!!this.__wideThumbScroll.scrollBy) {
            this.__wideThumbScroll.scrollBy({
                left: scrollHorizontal,
                behavior: 'smooth'
            });
        } else {
            this.__wideThumbScroll.scrollLeft += scrollHorizontal;
        }

        this.__lastThumbPosition = this.__position;
    }

    resetHorizontalScroll() {
        this.__wideThumbScroll.scroll({
            left: 0,
            behavior: 'smooth'
        });
    }

    deleteCoverClass() {
        this.__wideMediaContent.classList.remove('first-from-cover');
    }
}
